var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
import Maintenance from '../routes/maintenance';
import { mainApi } from '../../config';
var isDevStage = window.location.href.indexOf('localhost') !== -1 ||
    window.location.href.indexOf(':3000') !== -1 ||
    window.location.href.indexOf('tt-react-dev') !== -1 ||
    window.location.href.indexOf('tt-react-test') !== -1 ||
    window.location.href.indexOf('.dev.trainingtube.com') !== -1;
var maintenance = mainApi(isDevStage).maintenance;
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            compnent: null,
        };
        return _this;
    }
    Loader.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Component, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Component = null;
                        if (!maintenance) return [3 /*break*/, 17];
                        _a = this.props.route.path;
                        switch (_a) {
                            case '/login': return [3 /*break*/, 1];
                            case '/auto-login': return [3 /*break*/, 3];
                            case '/login-lp': return [3 /*break*/, 5];
                            case '/loginembed': return [3 /*break*/, 7];
                            case '/register': return [3 /*break*/, 9];
                            case '/reset-password': return [3 /*break*/, 11];
                            case '/forgot-password': return [3 /*break*/, 13];
                        }
                        return [3 /*break*/, 15];
                    case 1: return [4 /*yield*/, import('../routes/login/Login')];
                    case 2:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 3: return [4 /*yield*/, import('../routes/auto-login/AutoLogin')];
                    case 4:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 5: return [4 /*yield*/, import('../routes/login/LoginLP')];
                    case 6:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 7: return [4 /*yield*/, import('../routes/login/LoginEmbed')];
                    case 8:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 9: return [4 /*yield*/, import('../routes/register/Register')];
                    case 10:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 11: return [4 /*yield*/, import('../routes/reset-password/resetPassword')];
                    case 12:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 13: return [4 /*yield*/, import('../routes/forgot-password/forgotPassword')];
                    case 14:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 16];
                    case 15:
                        Component = Maintenance;
                        return [3 /*break*/, 16];
                    case 16:
                        this.setState({ compnent: Component });
                        return [2 /*return*/];
                    case 17:
                        _b = this.props.route.path;
                        switch (_b) {
                            case '/login': return [3 /*break*/, 18];
                            case '/auto-login': return [3 /*break*/, 20];
                            case '/login-lp': return [3 /*break*/, 22];
                            case '/loginembed': return [3 /*break*/, 24];
                            case '/register': return [3 /*break*/, 26];
                            case '/reset-password': return [3 /*break*/, 28];
                            case '/forgot-password': return [3 /*break*/, 30];
                            case '/admin/branding': return [3 /*break*/, 32];
                            case '/admin/organization': return [3 /*break*/, 34];
                            case '/admin/security': return [3 /*break*/, 36];
                            case '/admin/azure-ad': return [3 /*break*/, 38];
                            case '/admin/videos': return [3 /*break*/, 40];
                            case '/admin/channels': return [3 /*break*/, 42];
                            case '/subscriptions': return [3 /*break*/, 44];
                            case '/history': return [3 /*break*/, 46];
                            case '/library': return [3 /*break*/, 48];
                            case '/favorites': return [3 /*break*/, 50];
                            case '/tasks': return [3 /*break*/, 52];
                            case '/notifications': return [3 /*break*/, 54];
                            case '/my-videos': return [3 /*break*/, 56];
                            case '/sharings': return [3 /*break*/, 58];
                            case '/results': return [3 /*break*/, 60];
                            case '/orgs/usage': return [3 /*break*/, 62];
                            case '/orgs/crm': return [3 /*break*/, 64];
                            case '/orgs': return [3 /*break*/, 66];
                            case '/admin/users/usage': return [3 /*break*/, 68];
                            case '/admin/tracks': return [3 /*break*/, 70];
                            case '/admin/playlists': return [3 /*break*/, 70];
                            case '/admin/tasks': return [3 /*break*/, 72];
                            case '/admin/operationalTasks': return [3 /*break*/, 74];
                            case '/admin/users': return [3 /*break*/, 76];
                            case '/admin/tags': return [3 /*break*/, 78];
                            case '/admin/reports/shared': return [3 /*break*/, 80];
                            case '/admin/reports': return [3 /*break*/, 82];
                            case '/admin/information-classification': return [3 /*break*/, 84];
                            case this.props.isNewHomePage === true && '/home': return [3 /*break*/, 86];
                            case this.props.isNewHomePage === false && '/home': return [3 /*break*/, 88];
                            case '/mandatory': return [3 /*break*/, 90];
                            case '/support/chat': return [3 /*break*/, 92];
                            case '/video/:humanId': return [3 /*break*/, 94];
                            case '/video/:humanId/:version/:lang': return [3 /*break*/, 94];
                            case '/channel/:channelId/home': return [3 /*break*/, 96];
                            case '/channel/:channelId/videos': return [3 /*break*/, 98];
                            case '/channel/:channelId/tasks': return [3 /*break*/, 100];
                            case '/channel/create': return [3 /*break*/, 102];
                            case '/channel/edit/:channelId': return [3 /*break*/, 104];
                            case '/channel/:channelId/event-log': return [3 /*break*/, 106];
                            case '/channel/access-control/:channelId': return [3 /*break*/, 108];
                            case '/channel/recommendation/:channelId': return [3 /*break*/, 110];
                            case '/channel/:channelId/users': return [3 /*break*/, 112];
                            case '/channel/:channelId/reports/shared': return [3 /*break*/, 114];
                            case '/channel/:channelId/reports': return [3 /*break*/, 116];
                            case '/channel/:channelId/tracks': return [3 /*break*/, 118];
                            case '/channel/:channelId/playlists': return [3 /*break*/, 118];
                            case '/channel/:channelId/playlist/:trackId/share': return [3 /*break*/, 120];
                            case '/channel/:channelId/promotions': return [3 /*break*/, 122];
                            case '/playlist/create/:trackId': return [3 /*break*/, 124];
                            case '/track/create': return [3 /*break*/, 126];
                            case '/playlist/create': return [3 /*break*/, 126];
                            case '/playlist/edit/:trackId/translations': return [3 /*break*/, 128];
                            case '/playlist/edit/:trackId/share': return [3 /*break*/, 130];
                            case '/playlist/edit/:trackId': return [3 /*break*/, 132];
                            case '/track/edit/:trackId': return [3 /*break*/, 132];
                            case '/track/users/:trackId': return [3 /*break*/, 134];
                            case '/playlist/users/:trackId': return [3 /*break*/, 134];
                            case '/create/video': return [3 /*break*/, 136];
                            case '/edit/video/overview/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/effects': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/manuscript': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/quick-guide': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/links': return [3 /*break*/, 138];
                            case '/edit/video/ask-for-review/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/reports/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/shared/reports/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/tags/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/embed-codes/:videoId/:version/:section': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/upload-files': return [3 /*break*/, 138];
                            case '/edit/video/editor/:videoId/:version/:section/voice-over': return [3 /*break*/, 138];
                            case '/edit/video/:videoId/:version/:section/event-log': return [3 /*break*/, 138];
                            case '/edit/video/translator/:videoId/:version/:section/title': return [3 /*break*/, 140];
                            case '/edit/video/translator/:videoId/:version/:section/manuscript': return [3 /*break*/, 142];
                            case '/edit/video/translator/:videoId/:version/:section/quick-guide': return [3 /*break*/, 144];
                            case '/edit/video/translator/:videoId/:version/:section/links': return [3 /*break*/, 146];
                            case '/edit/video/translator/:videoId/:version/:section/caption': return [3 /*break*/, 148];
                            case '/edit/video/translator/:videoId/:version/:section/voice-annotation': return [3 /*break*/, 150];
                            case '/edit/video/translator/:videoId/:version/:section/effects': return [3 /*break*/, 152];
                            case '/edit/video/translator/:videoId/:version/:section/upload-files': return [3 /*break*/, 154];
                            case '/channel/:redirectId': return [3 /*break*/, 156];
                            case '/finance/features-services': return [3 /*break*/, 158];
                            case '/lp': return [3 /*break*/, 160];
                        }
                        return [3 /*break*/, 162];
                    case 18: return [4 /*yield*/, import('../routes/login/Login')];
                    case 19:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 20: return [4 /*yield*/, import('../routes/auto-login/AutoLogin')];
                    case 21:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 22: return [4 /*yield*/, import('../routes/login/LoginLP')];
                    case 23:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 24: return [4 /*yield*/, import('../routes/login/LoginEmbed')];
                    case 25:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 26: return [4 /*yield*/, import('../routes/register/Register')];
                    case 27:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 28: return [4 /*yield*/, import('../routes/reset-password/resetPassword')];
                    case 29:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 30: return [4 /*yield*/, import('../routes/forgot-password/forgotPassword')];
                    case 31:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 32: return [4 /*yield*/, import('../routes/admin/branding')];
                    case 33:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 34: return [4 /*yield*/, import('../routes/admin/organization')];
                    case 35:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 36: return [4 /*yield*/, import('../routes/admin/security')];
                    case 37:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 38: return [4 /*yield*/, import('../routes/admin/ssoConfig/AdminSsoConfig')];
                    case 39:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 40: return [4 /*yield*/, import('../routes/home')];
                    case 41:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 42: return [4 /*yield*/, import('../routes/admin/channels')];
                    case 43:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 44: return [4 /*yield*/, import('../routes/subscriptions')];
                    case 45:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 46: return [4 /*yield*/, import('../routes/history')];
                    case 47:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 48: return [4 /*yield*/, import('../routes/library')];
                    case 49:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 50: return [4 /*yield*/, import('../routes/favorites')];
                    case 51:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 52: return [4 /*yield*/, import('../routes/tasks')];
                    case 53:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 54: return [4 /*yield*/, import('../routes/notifications')];
                    case 55:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 56: return [4 /*yield*/, import('../routes/myVideos')];
                    case 57:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 58: return [4 /*yield*/, import('../routes/sharings')];
                    case 59:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 60: return [4 /*yield*/, import('../routes/searchResults')];
                    case 61:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 62: return [4 /*yield*/, import('../routes/orgsUsageList')];
                    case 63:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 64: return [4 /*yield*/, import('../routes/orgsUserCrm')];
                    case 65:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 66: return [4 /*yield*/, import('../routes/orgsList')];
                    case 67:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 68: return [4 /*yield*/, import('../routes/admin/usersUsage')];
                    case 69:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 70: return [4 /*yield*/, import('../routes/admin/tracks')];
                    case 71:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 72: return [4 /*yield*/, import('../routes/admin/tasks')];
                    case 73:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 74: return [4 /*yield*/, import('../routes/admin/operationalTasks')];
                    case 75:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 76: return [4 /*yield*/, import('../routes/admin/users')];
                    case 77:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 78: return [4 /*yield*/, import('../routes/admin/tags')];
                    case 79:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 80: return [4 /*yield*/, import('../routes/admin/sharedReports')];
                    case 81:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 82: return [4 /*yield*/, import('../routes/admin/reports')];
                    case 83:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 84: return [4 /*yield*/, import('../routes/admin/infClassification')];
                    case 85:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 86: return [4 /*yield*/, import('../routes/mandatory/HomePageContainer')];
                    case 87:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 88: return [4 /*yield*/, import('../routes/home')];
                    case 89:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 90: return [4 /*yield*/, import('../routes/mandatory/MandatoryContainer')];
                    case 91:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 92: return [4 /*yield*/, import('../routes/chat')];
                    case 93:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 94: return [4 /*yield*/, import('../routes/video/home')];
                    case 95:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 96: return [4 /*yield*/, import('../routes/channel/home')];
                    case 97:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 98: return [4 /*yield*/, import('../routes/channel/videos')];
                    case 99:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 100: return [4 /*yield*/, import('../routes/channel/tasks')];
                    case 101:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 102: return [4 /*yield*/, import('../routes/channel/create/ChannelCreate')];
                    case 103:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 104: return [4 /*yield*/, import('../routes/channel/edit/overview')];
                    case 105:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 106: return [4 /*yield*/, import('../routes/channel/edit/update-history')];
                    case 107:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 108: return [4 /*yield*/, import('../routes/channel/edit/access-control')];
                    case 109:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 110: return [4 /*yield*/, import('../routes/channel/edit/recommendation')];
                    case 111:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 112: return [4 /*yield*/, import('../routes/channel/users/ChannelUsers')];
                    case 113:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 114: return [4 /*yield*/, import('../routes/channel/sharedReports')];
                    case 115:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 116: return [4 /*yield*/, import('../routes/channel/reports')];
                    case 117:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 118: return [4 /*yield*/, import('../routes/channel/tracks')];
                    case 119:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 120: return [4 /*yield*/, import('../routes/track/share')];
                    case 121:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 122: return [4 /*yield*/, import('../routes/channel/promotions')];
                    case 123:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 124: return [4 /*yield*/, import('../routes/track/create')];
                    case 125:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 126: return [4 /*yield*/, import('../routes/track/create')];
                    case 127:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 128: return [4 /*yield*/, import('../routes/track/edit/translations')];
                    case 129:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 130: return [4 /*yield*/, import('../routes/track/edit/share')];
                    case 131:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 132: return [4 /*yield*/, import('../routes/track/edit/overview')];
                    case 133:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 134: return [4 /*yield*/, import('../routes/track/edit/users')];
                    case 135:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 136: return [4 /*yield*/, import('../routes/video/create/VideoCreate')];
                    case 137:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 138: return [4 /*yield*/, import('../routes/video-edit')];
                    case 139:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 140: return [4 /*yield*/, import('../routes/video-edit/translate/VideoTranslate')];
                    case 141:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 142: return [4 /*yield*/, import('../routes/video-edit/translate/VideoManuscript')];
                    case 143:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 144: return [4 /*yield*/, import('../routes/video-edit/translate/VideoQuickGuide')];
                    case 145:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 146: return [4 /*yield*/, import('../routes/video-edit/translate/VideoLinks')];
                    case 147:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 148: return [4 /*yield*/, import('../routes/video-edit/translate/VideoCaptions')];
                    case 149:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 150: return [4 /*yield*/, import('../routes/video-edit/translate/VideoVoiceOver')];
                    case 151:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 152: return [4 /*yield*/, import('../routes/video-edit/translate/VideoEditor')];
                    case 153:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 154: return [4 /*yield*/, import('../routes/video-edit/translate/VideoUploadFile')];
                    case 155:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 156: return [4 /*yield*/, import('../routes/channel/redirect')];
                    case 157:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 158: return [4 /*yield*/, import('../routes/admin/features-services')];
                    case 159:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 160: return [4 /*yield*/, import('../routes/sso-login')];
                    case 161:
                        Component = (_c.sent()).default;
                        return [3 /*break*/, 163];
                    case 162:
                        Component = Maintenance;
                        return [3 /*break*/, 163];
                    case 163:
                        this.setState({ compnent: Component });
                        return [2 /*return*/];
                }
            });
        });
    };
    Loader.prototype.render = function () {
        var Component = this.state.compnent;
        var isAutoLogin = this.props.route.path === '/auto-login';
        return Component ? (React.createElement(Component, __assign({}, this.props))) : isAutoLogin ? (React.createElement("div", { className: "w-100 h-100", style: { background: '#3C4252' } })) : null;
    };
    return Loader;
}(React.PureComponent));
var mapStateToProps = function (state) {
    var _a;
    return ({
        orgId: state.auth.organization.id,
        isNewHomePage: ((_a = state.auth.organization.featureFlags.filter(function (e) { return e.featureId === 'new-home-page'; })[0]) === null || _a === void 0 ? void 0 : _a.configuration) === 'tube',
    });
};
export default connect(mapStateToProps, null)(Loader);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/Loader.tsx
// module id = 1810
// module chunks = 81